import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { PrimeIcons } from 'primeng/api';
import {
  DesignToken,
  DesignTokenLevel,
  DesignTokenLevelColors,
  DesignTokenLevelExplanations,
  DesignTokenLevelShortLabels,
} from '@tokenbox/domain';
import { Tag } from 'primeng/tag';
import { Tooltip } from 'primeng/tooltip';
import { DesignTokenLevelIcons } from '../design-tokens/design-token-level-icons';

@Component({
  selector: 'lib-level-label',
  imports: [Tag, Tooltip],
  templateUrl: './level-label.component.html',
  styleUrl: './level-label.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LevelLabelComponent {
  level = input.required<DesignTokenLevel>();

  protected readonly PrimeIcons = PrimeIcons;

  protected label = computed(() => DesignTokenLevelShortLabels[this.level()]);

  protected _icon = computed(() => DesignTokenLevelIcons[this.level()]);

  protected color = computed(() => DesignTokenLevelColors[this.level()]);

  protected tooltip = computed(
    () => `${DesignTokenLevelExplanations[this.level()]}`,
  );
}
